/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Adminsubs_Pendingcancel2Inputs */

const zh_adminsubs_pendingcancel2 = /** @type {(inputs: Adminsubs_Pendingcancel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`待取消`)
};

const en_adminsubs_pendingcancel2 = /** @type {(inputs: Adminsubs_Pendingcancel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pending cancel`)
};

const es_adminsubs_pendingcancel2 = /** @type {(inputs: Adminsubs_Pendingcancel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancelación pendiente`)
};

/**
* | output |
* | --- |
* | "Pending cancel" |
*
* @param {Adminsubs_Pendingcancel2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const adminsubs_pendingcancel2 = /** @type {((inputs?: Adminsubs_Pendingcancel2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Adminsubs_Pendingcancel2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_adminsubs_pendingcancel2(inputs)
	if (locale === "en") return en_adminsubs_pendingcancel2(inputs)
	return es_adminsubs_pendingcancel2(inputs)
});
export { adminsubs_pendingcancel2 as "adminSubs_pendingCancel" }